import moment from 'moment/moment'

export const formatDate = (value: string) => {
  if (value) {
    return moment(String(value)).format('MMMM/DD/YYYY hh:mm')
  }
}

export const formatDateWithoutTime = (value: string) => {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
}
// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Filter to thousand format (1000 => 1.000, 10000 => 10k)
export const thousandsFormat = (value: number) => {
  if (value >= 10000) {
    return Math.floor(value / 1000) + 'k'
  }

  if (value >= 1000) {
    const thousands = Math.floor(value / 1000)

    return thousands + '.' + (value - thousands * 1000)
  }

  return '' + value
}

export const thumb64 = (image: any) => {
  if (image !== undefined && image !== null && image.thumb_64 !== undefined) {
    return image.thumb_64
  }

  return require('@/img/category.png')
}

export const avatar64 = (image: any) => {
  if (image !== undefined && image !== null && image.thumb_64 !== undefined) {
    return image.thumb_64
  }

  return require('@/img/avatar.png')
}

export const avatar128 = (image: any) => {
  if (image !== undefined && image !== null && image.thumb_64 !== undefined) {
    return image.thumb_128
  }

  return require('@/img/avatar.png')
}
